var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAk25121270(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 146.8 30",
    style: {
      enableBackground: "new 0 0 146.8 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 99.4,
    y: -6.7,
    transform: "matrix(0.4702 -0.8825 0.8825 0.4702 46.284 92.242)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 20.8,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 2.6783 52.7325)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.2,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.5,30H86.4V0h30.1V30z M87.6,28.8h27.8V1.2H87.6V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.1,25.9H90.3V3.7h22.8V25.9z M91.5,24.8H112v-20H91.5V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: -6.7,
    transform: "matrix(0.4704 -0.8824 0.8824 0.4704 0.5132 15.9926)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.4,
    y: 20.8,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -8.7991 9.7026)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.7,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1,30H0V0h30.1V30z M1.2,28.8H29V1.2H1.2V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7,25.9H4V3.7h22.8V25.9z M5.1,24.8h20.5v-20H5.1V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.7,
    y: -6.7,
    transform: "matrix(0.4702 -0.8825 0.8825 0.4702 15.7199 41.3255)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.3,
    y: 20.8,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -4.9856 23.9999)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8,30H28.7V0h30.1V30z M29.9,28.8h27.8V1.2H29.9V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4,25.9H32.7V3.7h22.8V25.9z M33.8,24.8h20.5v-20H33.8V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.7,
    y: -6.7,
    transform: "matrix(0.4704 -0.8825 0.8825 0.4704 31.0671 66.9037)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 20.8,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -1.1352 38.4353)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8,30H57.7V0h30.1V30z M58.8,28.8h27.8V1.2H58.8V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4,25.9H61.7V3.7h22.8V25.9z M62.8,24.8h20.5v-20H62.8V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.2,
    y: -6.7,
    transform: "matrix(0.4702 -0.8825 0.8825 0.4702 61.5658 117.7)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.8,
    y: 20.8,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 6.5103 67.0988)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.4,30h-30.1V0h30.1V30z M116.4,28.8h27.8V1.2h-27.8V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,25.9h-22.8V3.7H142V25.9z M120.3,24.8h20.5v-20h-20.5V24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.3,29.6c-0.2,0-0.4-0.1-0.5-0.3l-1-2.1c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3l1,2.1c0.1,0.3,0,0.6-0.3,0.8 L144.3,29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.8,24.6c-0.2,0-0.4-0.1-0.5-0.3l-2-3.9c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3l2,3.9c0.1,0.3,0,0.6-0.3,0.8 L141.8,24.6z M138.3,17.7c-0.2,0-0.4-0.1-0.5-0.3l-2-3.9c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3l2,3.9 c0.1,0.3,0,0.6-0.3,0.8L138.3,17.7z M134.9,10.9c-0.2,0-0.4-0.1-0.5-0.3l-2-3.9c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3 l2,3.9c0.1,0.3,0,0.6-0.3,0.8L134.9,10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.5,4c-0.2,0-0.4-0.1-0.5-0.3l-1-2.1c-0.1-0.3,0-0.6,0.3-0.8c0.3-0.1,0.6,0,0.8,0.3l1,2.1c0.1,0.3,0,0.6-0.3,0.8 L131.5,4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.6,29.6l-0.3-0.1c-0.3-0.1-0.4-0.5-0.3-0.8l2.1-4.1c0.1-0.3,0.5-0.4,0.8-0.3c0.3,0.1,0.4,0.5,0.3,0.8l-2.1,4.1 C117,29.5,116.8,29.6,116.6,29.6z M120.2,22.4l-0.3-0.1c-0.3-0.1-0.4-0.5-0.3-0.8l2.1-4.1c0.1-0.3,0.5-0.4,0.8-0.3 c0.3,0.1,0.4,0.5,0.3,0.8l-2.1,4.1C120.6,22.3,120.4,22.4,120.2,22.4z M123.8,15.2l-0.3-0.1c-0.3-0.1-0.4-0.5-0.3-0.8l2.1-4.1 c0.1-0.3,0.5-0.4,0.8-0.3c0.3,0.1,0.4,0.5,0.3,0.8l-2.1,4.1C124.2,15.1,124,15.2,123.8,15.2z M127.4,7.9l-0.3-0.1 c-0.3-0.1-0.4-0.5-0.3-0.8L129,3c0.1-0.3,0.5-0.4,0.8-0.3c0.3,0.1,0.4,0.5,0.3,0.8l-2.1,4.1C127.8,7.8,127.6,7.9,127.4,7.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAk25121270);
export default __webpack_public_path__ + "static/media/AK2_5_12127_0.59a759e2c473708cb8f2b5b65ef79fa0.svg";
export { ForwardRef as ReactComponent };